/**
 * Strip HTML tags from a rich-text (Quill) description and return clean
 * plain text suitable for list/card previews.
 *
 * - Replaces tags with a space so adjacent words don't run together
 *   (e.g. <h2>Title</h2><p>Body</p> becomes "Title Body", not "TitleBody")
 * - Decodes common HTML entities (&nbsp;, &amp;, &lt;, &gt;, &quot;, &#39;)
 * - Collapses consecutive whitespace into a single space
 * - Trims leading/trailing whitespace
 */
export function stripHtmlToText(html) {
  if (!html) return '';
  return String(html)
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/\s+/g, ' ')
    .trim();
}
